import { render, staticRenderFns } from "./Agree-Dialog.vue?vue&type=template&id=3f617dfe"
import script from "./Agree-Dialog.vue?vue&type=script&lang=js"
export * from "./Agree-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports